// Custom easing for luxurious animations
export const luxuriousEasing = [0.25, 0.1, 0.25, 1]; // Custom cubic-bezier for smooth transitions

// Custom animation variants with longer durations for smooth transitions
export const cardVariants = {
  initial: {
    opacity: 0,
    scale: 0.96,
    y: -10,
  },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 1, // Longer duration for luxury feel
      ease: luxuriousEasing,
      staggerChildren: 0.08,
    }
  },
  exit: {
    opacity: 0,
    scale: 0.96,
    y: 10,
    transition: {
      duration: 0.6,
      ease: luxuriousEasing
    }
  }
};

// Layout transition configuration
export const layoutTransition = {
  type: "spring",
  stiffness: 250,
  damping: 30,
  mass: 0.9,
  duration: 1.1
};
